import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class DiagStackOtxMappers {
  otxResponseParser<T>(otxResponse: string): T {
    try {
      const parsed = JSON.parse(otxResponse);

      return parsed;
    } catch {
      console.error('Otx response failed to parse');

      return null;
    }
  }
}
